export const Host = process.env.REACT_APP_HOST_URL
export const Domain = process.env.REACT_APP_DOMAIN